import { VStack } from 'native-base';
import Tabs from 'ui/components/Tabs';

import { ActivityFormContainer } from '~/components/ActivityFormBuilderPresets/components/ActivityFormContainer';
import { MediaForm } from '~/components/MediaForm';
import Scaffold from '~/components/Scaffold';
import { colors } from '~/theme/colors';

import { eventFormTabsElements } from '../../tabsElements';
import { EventFormTabsPages } from '../../types';
import { AboutForm } from './AboutForm';
import { useEventFormController } from './controller';
import { WhenWhereForm } from './WhenWhereForm';

export const EventForm = () => {
  const {
    tabsRef,
    currentTab,
    causeOptions,
    requirementOptions,
    formData,
    handleBack,
    handleContinue,
    isTeamEvent,
    isLoading,
    filteredAppsByPermissions,
    handleUpdateEventApplication,
    handleUpdateLocationOption,
    currentLocationOption,
  } = useEventFormController();

  const renderTabs = () => {
    return {
      [EventFormTabsPages.About]: (
        <AboutForm
          handleContinue={handleContinue}
          handleBack={handleBack}
          causeOptions={causeOptions}
          requirementOptions={requirementOptions}
          defaultValues={formData}
          isLoading={isLoading}
          connectedApps={filteredAppsByPermissions}
          handleUpdateEventApplication={handleUpdateEventApplication}
        />
      ),
      [EventFormTabsPages.Media]: (
        <MediaForm
          handleBack={handleBack}
          handleContinue={handleContinue}
          defaultValues={formData}
          isLoading={isLoading}
        />
      ),
      [EventFormTabsPages.WhenWhere]: (
        <WhenWhereForm
          handleBack={handleBack}
          handleContinue={handleContinue}
          isTeamEvent={isTeamEvent}
          isLoading={isLoading}
          handleUpdateLocationOption={handleUpdateLocationOption}
          currentLocationOption={currentLocationOption}
        />
      ),
    }[currentTab];
  };

  return (
    <Scaffold title="Add new event" alignItemsChildren="center">
      <ActivityFormContainer>
        <VStack w="100%" alignItems="center" pb={10}>
          <Tabs
            ref={tabsRef}
            tabBgColor="transparent"
            tabWith="100%"
            tabTextColor={colors.primary['600']}
            tabIndicatorColor={colors.primary['600']}
            tabfocusedTextColor={colors.primary['600']}
            swipeEnabled={false}
            elements={eventFormTabsElements}
            currentTab={currentTab}
          />
        </VStack>
        {renderTabs()}
      </ActivityFormContainer>
    </Scaffold>
  );
};
